import Index from './Index.vue';

export default {
  path: 'atendimentos',
  name: 'config-atendimento',
  component: Index,
};
